module.exports = __webpack_public_path__ + "img/center.78787667.png";